import React from 'react';
import { useAppSelector } from '../../store/store';
import styles from './RegionSeoContent.less';
var selectShowRegionSeoContent = function selectShowRegionSeoContent(state) {
  var _ref, _state$config;
  return (_ref = (_state$config = state.config) === null || _state$config === void 0 ? void 0 : _state$config.SHOW_REGION_SEO_CONTENT) !== null && _ref !== void 0 ? _ref : false;
};
var RegionSeoContent = function RegionSeoContent() {
  var isEnabled = useAppSelector(selectShowRegionSeoContent);
  var blocks = useAppSelector(function (state) {
    return state.regionSeoContent.blocks;
  });
  if (!isEnabled || !blocks || blocks.length === 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "content-wrapper padding-top padding-bottom lap-padding-horizontal-l palm-padding-horizontal-l"
  }, blocks.map(function (block, index) {
    return block.type === 'h2' ? /*#__PURE__*/React.createElement("h2", {
      key: index,
      className: styles.heading
    }, block.text) : /*#__PURE__*/React.createElement("p", {
      key: index,
      className: styles.paragraph
    }, block.text);
  }), /*#__PURE__*/React.createElement("p", {
    className: styles.disclaimer
  }, "Disclaimer: Die dargestellten Kennzahlen beruhen auf einer aggregierten, stichtagsbezogenen Auswertung regionaler Profil-, Bewertungs- und Angebotsdaten von ImmoScout24. Sie dienen ausschlie\xDFlich der allgemeinen Orientierung, k\xF6nnen sich laufend \xE4ndern und durch Rundungen, unterschiedliche Datenst\xE4nde oder methodische Anpassungen abweichen; eine Aussage \xFCber die Bewertung, Qualit\xE4t oder Leistung einzelner Immobilienmakler ist damit nicht verbunden."));
};
export default RegionSeoContent;